import ReactMarkdown from 'react-markdown'

import {
  GRETA_AI_CHAT_MARKDOWN_COMPONENTS,
  GRETA_AI_CHAT_MARKDOWN_PLUGINS,
} from './GretaAIChatMarkdown.constants'

import * as styles from './GretaAIChatMarkdown.module.css'

function GretaAIChatMarkdown({ text }) {
  return (
    <div className={styles.markdown}>
      <ReactMarkdown
        components={GRETA_AI_CHAT_MARKDOWN_COMPONENTS}
        remarkPlugins={GRETA_AI_CHAT_MARKDOWN_PLUGINS}
      >
        {text}
      </ReactMarkdown>
    </div>
  )
}

export default GretaAIChatMarkdown
